import { Divider } from '../../../../../../components/divider/divider';
import { Button } from '../../../../../../components/form/button';
import { Modal } from '../../../../../../components/modal/modal';
import { Spinner } from '../../../../../../components/spinner/spinner';
import { StatusTransitionPayment } from '../../../status-transition-payment';
import { useCollectPaymentModal } from './hooks/use-collect-payment';

export const CollectPaymentModal = ({
  orderId,
  onCancel,
  onComplete,
}: {
  onCancel: () => void;
  orderId: number;
  onComplete: () => void;
}) => {
  const {
    postPayment,
    isLoading,
    isPaying,
    order,
    paymentMethod,
    setPaymentMethod,
    setAmount,
    amount,
    facilitate,
    payments,
    setPayments,
    onClose,
    isOpen,
  } = useCollectPaymentModal(orderId, onCancel, onComplete);

  return (
    <Modal
      title="Collect Payment"
      isOpen={isOpen}
      close={onClose}
      actions={
        <>
          <Button
            className="button button-secondary"
            onClick={onClose}
            disabled={isPaying}
            dataCy="skip-for-now-button"
          >
            Skip For Now
          </Button>
          <Button
            className="button button-yellow"
            disabled={isPaying || !paymentMethod || amount <= 0}
            onClick={() => postPayment(payments)}
            dataCy="collect-payment-button"
          >
            {isPaying ? (
              <div className="flex items-center gap-2" data-cy="collect-payment-button-loading">
                <Spinner />
                Collecting...
              </div>
            ) : (
              'Collect'
            )}
          </Button>
        </>
      }
    >
      {isLoading || !order ? (
        <div data-cy="collect-payment-button-loading">
          <Spinner />
        </div>
      ) : (
        <>
          <Divider />
          <StatusTransitionPayment
            order={order}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            total={order.invoices?.find((inv) => inv)?.total ?? 0}
            paymentTotal={
              (order.invoices?.find((inv) => inv)?.total ?? 0) - (order.invoices?.find((inv) => inv)?.balance ?? 0)
            }
            amount={amount.toFixed(2)}
            setAmount={(a) => setAmount(Number(a))}
            onComplete={postPayment}
            facilitate={facilitate}
            payments={payments}
            setPayments={setPayments}
            defaultPercentage={100}
          />
        </>
      )}
    </Modal>
  );
};
